<template>
	<form v-if="formfields.length > 0" class="v-userform" v-on:submit.prevent="save">
		<div ref="fieldset" v-for="field in formfields" :is="'f-' + field.type" v-if="field.fields.length > 0" :key="field.name" :field="field"></div>
		<div v-if="isnew" class="st-form__fieldset">
		    <div class="st-notice">
		        <div class="row">
		            <div class="col-xs-12 col-sm-1">
		                <i class="fa fa-hand-o-right" aria-hidden="true"></i>
		            </div>
		            <div class="col-xs-12 col-sm-11">
		                <div class="user-content-wrapper">
		                    {{ $t("After submitting this form, an automatic e-mail will be sent with login information to the specified address.") }}
		                </div>
		            </div>
		        </div>
		    </div>
		</div>

		<div class="st-form__fieldset">
			<div class="row">
				<div class="col-xs-12 col-sm-6">
					<!--<button type="button" @click="router.go(-1)" :title="$t('Cancel')" class="no-btn inline-nav">{{ $t('Cancel') }}</button>-->
				</div>
				<div class="col-xs-12 col-sm-6 text-sm-right">
					<button @click="create" v-if="isnew" type="button" class="st-btn st-btn--submit" :class="{'st-btn--loading':saveing}" :disabled="saveing">{{ $t('Create') }}</button>
					<button @click="save" v-else type="button" class="st-btn st-btn--submit":class="{'st-btn--loading':saveing}" :disabled="saveing">{{ $t('Save') }}</button>
				</div>
			</div>
		</div>

		<div class="st-form__fieldset" v-if="$store.getters.edituser && $store.getters.edituser.permissions">
			<div class="row st-form__row">
				<div class="col-xs-12">
					<div  v-if="$store.getters.edituser.permissions.can_request_password" class="st-link-block">
						<a href="#" @click.prevent="requestPasswortEmail" class="st-link">Send activation email again</a>
					</div>
					<div  v-if="$store.getters.edituser.permissions.can_delete" class="st-link-block">
						<a href="#" @click.prevent="startdeleteuser" class="st-link st-link--delete">{{ $t("Irrevocably delete this account.") }}</a>
						<v-tooldown v-if="deleteel && isdeleting" :loading="loading" :type="'delete'" :el="deleteel" :yesno="true" @ok="deleteuser" @cancel="stopdeleteuser">
				        	<span v-cloak slot="title">{{ $t('Delete User') }}</span>
				        	<span v-cloak slot="message">{{ $t('Do you really want to delete this user.') }}</span>
				        	<span v-cloak slot="positive">{{ $t('Delete') }}</span>
				        </v-tooldown>
					</div>
				</div>
			</div>
		</div>
	</form>
</template>

<script>

import help_rest from '@/helpers/rest';
import FFieldset from '@/components/form/f-fieldset';

export default {
	name: 'v-userform',
	components: {
		FFieldset
	},
	computed: {
		saveing(){
			return this.$store.getters.saveing;
		},
	},
	data(){
		return {
			loading: false,
  			isdeleting: false,
  			deleteel: false
		}
	},
	props: {
		formfields: {
			type: Array,
			default(){
				return [];
			}
		},
		isnew: {
			type: Boolean,
			default: true
		},
		uid: {
			default: ''
		},
		rolename: {
			type: String,
			default: ''
		}
	},
	methods: {
		startdeleteuser(event){
			this.deleteel = event.target;
			this.isdeleting = !this.isdeleting;
		},
		deleteuser(){
			const self = this,
				  url = (this.data && this.data.urls && this.data.urls.delete ? this.data.urls.delete : this.$store.getters.channel.urls.user.replace(':id:', this.data.id));

			self.loading = true;
			this.restdelete(url, 'delete')
			.then(message => {
				self.loading = false;
				self.$emit('delete');
				this.stopdeleteuser();
			});

		},
		stopdeleteuser(){
			this.deleteel = false;
			this.isdeleting = false;
		},
		...help_rest,
		getSaveableFields(fields){
			const self = this;
			let out = {};
			fields.forEach(item => {
				if(item.type == "image") return; //weiter

				if(typeof item.value !== 'undefined'){
					out[item.name] = item.value;
				}

				if(item.fields){
					out = Object.assign({}, out, self.getSaveableFields(item.fields));
				}
			});
			return out;
		},
		getAndValidEdituser(){
			const self = this;
			return new Promise((resolve, reject) => {

				let promises = []
				for (let child in self.$refs.fieldset) {
		        	promises.push(self.$refs.fieldset[child].validate());
		      	}

		      	Promise.all(promises)
				.then((result) => {
					const user = self.$store.getters.edituser;
					let payload = self.getSaveableFields(user.fields);
					resolve(payload);
				})
				.catch(errors => {
					reject(errors)
				});
			});
		},
		create(ev){
			const self = this;
			ev.preventDefault();

			this.getAndValidEdituser()
			.then(payload => {
				self.restput(self.$store.getters.channel.urls.users + '/' + self.rolename, payload, 'saveing')
				.then(message => {

				});
			})
			.catch(errors => {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		save(ev){
			const self = this;
			ev.preventDefault();
			console.log('save', ev);

			this.getAndValidEdituser()
			.then(payload => {
				self.restpatch(self.$store.getters.channel.urls.user.replace(':id:', self.uid), payload, 'saveing')
				.then(message => {
					console.log(message);
				});
			})
			.catch(errors => {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		promotToLeader(ev){

		},
		requestPasswortEmail(ev){
			var email = this.$store.getters.getEditFieldById('email');
			if(email){
				this.restpatch('/api/v1/request_password', { email : email.value }, 'request_password')
					.then(message => {
						console.log(message);
					});
			}
		}
	}
}
</script>

<style scoped lang="scss">
.error{
	color: #a3248f;
}

.st-link-block {
    padding: 1.555555556em 0;
    border-top: 1px solid #E4E6EB;

    &:last-child {
    	border-bottom: 1px solid #E4E6EB
    }
}
</style>



// WEBPACK FOOTER //
// src/components/form/v-userform.vue